<template>
  <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
  />
  <div v-else>
    <h1 class="text-center mt-3">
      Official Website
    </h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">

      <div class="row">
        <div class="col-12 col-md-4 mb-3">
          <label for="customerCode">Customer Code</label>
          <input
              v-model="customerCode"
              type="text"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorCustomerCode,
              }"
              @keyup.enter="searchUserMappings"
          />
          <div v-if="isSubmit && error.errorCustomerCode" class="text-error">
            {{ error.errorCustomerCode.message }}
          </div>
        </div>

        <div class="col-12 col-md-4 mb-3">
          <label for="phoneNumber">Mobile Phone</label>
          <input
              v-model="phoneNumber"
              type="text"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorPhoneNumber,
              }"
              @keyup.enter="searchUserMappings"
          />
          <div v-if="isSubmit && error.errorPhoneNumber" class="text-error">
            {{ error.errorPhoneNumber.message }}
          </div>
        </div>

        <div class="col-12 col-md-4 mb-3 d-flex align-items-end justify-content-center">
          <button
              class="btn btn-outline-secondary mr-2"
              @click="resetFilter"
          >
            Reset
          </button>
          <button
              class="btn btn-outline-success"
              @click="searchUserMappings"
          >
            OK
          </button>
        </div>
      </div>

      <div class="mt-1">

        <b-table
            class="table table-bordered"
            hover
            responsive
            :fields="tableFields"
            :items="listUser"
            :busy="isBusy"
            @sort-changed="onSortChanged"
        >
          <template #cell(actions)="{ item }">
            <div class="d-flex justify-content-start align-items-center w-100">
              <button
                  @click="
              $router.push({
                name: 'UserRevocationDetail',
                query: { customerNumber: item.customerNumber ,brandCode: item.brandCode },
                params: { isRevoke: true }
              })
            "
                  class="btn btn-danger btn-sm me-2"
              >
                ลบการเชื่อมต่อ
              </button>
              <button
                  @click="openAddBillDialog(item)"
                  class="btn btn-success btn-sm"
              >
                เพิ่มบิล
              </button>
            </div>
          </template>
        </b-table>

      </div>
    </div>

    <v-dialog v-model="showAddBillDialog" max-width="500" persistent>
      <div class="bg-white p-4 rounded">
        <h5 class="mb-3">เพิ่มบิลจาก Official website</h5>
        <p class="mb-3">
          ต้องเป็นหมายเลขคำสั่งซื้อของลูกค้าที่จัดส่งสำเร็จแล้วเท่านั้น
        </p>

        <label for="orderNumber">หมายเลขคำสั่งซื้อบน Official website</label>
        <input
            id="orderNumber"
            v-model="orderNumber"
            type="text"
            class="form-control mb-4"
        />

        <div class="text-right">
          <button
              class="btn btn-outline-secondary mr-2"
              @click="showAddBillDialog = false"
          >
            ยกเลิก
          </button>
          <button
              class="btn btn-outline-success"
              @click="submitAddBill"
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="showAddBillSuccessDialog" max-width="400">
      <div class="bg-white p-4 rounded">
        <h5 class="mb-3 font-weight-bold">เพิ่มบิลสำเร็จ</h5>
        <p class="mb-4">
          ลูกค้าได้รับคะแนนเพิ่มขึ้น
          {{ formatPoints(addBillResult.points) }}
          คะแนน ในปี {{ addBillResult.year + 543 }}
        </p>
        <div class="text-right">
          <button
              class="btn btn-outline-success px-4"
              @click="showAddBillSuccessDialog = false"
          >
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>

  </div>
</template>
<script>

import BrandDropdown from "components/Brand/BrandDropdown.vue";
import OfficialWebsiteService from "services/api/officialWebsite.service";
import moment from "moment";

export default {
  name: "OfficialWebsitePage",
  components: {BrandDropdown},
  data() {
    return {
      isLoading: false,
      isBusy: false,
      isSubmit: false,
      customerCode: "",
      phoneNumber: "",
      listUser: [],
      tableFields: [
        {key: "brandName", label: "Brand", sortable: true},
        {key: "customerNumber", label: "Brand.com customer number", sortable: true},
        {key: "dateCreated", label: "วันที่เชื่อมต่อ", sortable: true},
        {key: "pointBalance", label: "Point balance", sortable: false},
        {key: "redeemablePoints", label: "Redeemable points", sortable: false},
        {key: "actions", label: "Actions"},
      ],
      sortState: {key: "brandCode", type: "desc"},
      error: {
        errorBrand: null,
        errorPhoneNumber: null,
        errorCustomerCode: null,
      },

      showAddBillDialog: false,
      showAddBillSuccessDialog: false,
      orderNumber: "",
      selectedUser: null,
      addBillResult: {
        points: null,
        year: null,
      },
    };
  },
  mounted() {
    this.restoreFilterFromRoute();
  },
  methods: {
    restoreFilterFromRoute() {
      const q = this.$route.query;
      if (!q || Object.keys(q).length === 0) {
        return;
      }

      this.customerCode = q.customerCode || "";
      this.phoneNumber = q.phoneNumber || "";

      if (q.sortKey) {
        this.sortState = {
          key: q.sortKey,
          type: q.sortType || "desc",
        };
      }
      this.searchUserMappings();
    },
    searchUserMappings() {
      this.isLoading = true;
      this.$router.replace({
        name: "OfficialWebsiteUser",
        query: {
          customerCode: this.customerCode || "",
          phoneNumber: this.phoneNumber || "",
          sortKey: this.sortState.key,
          sortType: this.sortState.type,
        },
      });
      this.getListUserMappings(this.sortState);
    },
    async getListUserMappings(sort) {
      this.isSubmit = true;
      this.resetErrorText();
      let sortColumn = sort.key;

      if (sort.key === "brandName") {
        sortColumn = "brandCode";
      }

      const params = {
        phoneNumber: this.phoneNumber,
        customerCode: this.customerCode,
        sortColumn,
        sortType: sort.type === "asc" ? "asc" : "desc",
      };

      await OfficialWebsiteService.getListUserMappings(params)
          .then((res) => {
            const data = res.data;
            this.listUser = data.mappings.map((c) => {
              const m = moment(c.dateCreated, moment.ISO_8601).locale("th");
              const date = m.format("YYYY-MM-DD HH:mm:ss");
              return {
                ...c,
                pointBalance: this.formatPoints(c.pointBalance),
                redeemablePoints: this.formatPoints(c.redeemablePoints),
                dateCreated: date,
              };
            });

            this.isLoading = false;
          })
          .catch((err) => {
            this.handleError(err);
            this.isLoading = false;
          });
    },
    onSortChanged(e) {
      let sortBy = e.sortBy;
      this.sortState = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getListUserMappings(this.sortState);
    },

    resetFilter() {
      this.isSubmit = false;
      this.phoneNumber = null;
      this.customerCode = "";
      this.resetErrorText();
    },

    handleError(err) {
      const errorData = err.response?.data;
      if (errorData?.errors?.length > 0) {
        this.listUser = [];
        this.setErrorText(errorData.errors);
      } else if (errorData?.message) {
        alert(errorData.message);
      }
    },

    setErrorText(errors) {
      this.error.errorPhoneNumber = errors.find((e) => e.fieldName === "phoneNumber") || null;
      this.error.errorCustomerCode = errors.find((e) => e.fieldName === "customerCode") || null;
    },

    resetErrorText() {
      this.error = {
        errorPhoneNumber: null,
        errorCustomerCode: null,
      };
    },

    openAddBillDialog(item) {
      this.selectedUser = item || null;
      this.orderNumber = "";
      this.showAddBillDialog = true;
    },

    async submitAddBill() {
      if (!this.orderNumber) {
        alert("กรุณากรอกหมายเลขคำสั่งซื้อบน Official website");
        return;
      }

      this.isLoading = true;
      try {
        const params = {
          orderNumber: this.orderNumber,
          customerNumber: this.selectedUser.customerNumber,
          brandCode: this.selectedUser.brandCode,
        };

        const response = await OfficialWebsiteService.addOfficialWebsiteOrder(params);

        this.addBillResult = {
          points: response.data.earnedPoints ?? 0,
          year: response.data.pointYear ?? new Date().getFullYear(),
        };

        this.showAddBillDialog = false;
        this.showAddBillSuccessDialog = true;

        await this.getListUserMappings(this.sortState);
      } catch (err) {
        const errorData = err.response?.data;
        alert(errorData?.message ?? "เกิดข้อผิดพลาดในการเพิ่มข้อมูล");
      } finally {
        this.isLoading = false;
      }
    },

    formatPoints(val) {
      if (val == null) return 0;
      const num = Number(val);
      if (Number.isNaN(num)) return val;
      return num.toLocaleString();
    },
  },
};
</script>
<style scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>